<template>
    <DanhSachQuyenTrongApp/>
</template>
<script>
import DanhSachQuyenTrongApp from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTrongApp";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";
export default {
    name: "TrangDanhSachQuyen",
    components:{
        DanhSachQuyenTrongApp,
    },
    created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.PERMISSION.NAME
      }`
    );
  }
}
</script>